"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImmutableStatuses = exports.RenderAs = exports.ActivityParticipantStatus = void 0;
var ActivityParticipantStatus;
(function (ActivityParticipantStatus) {
    ActivityParticipantStatus["NEW"] = "new";
    ActivityParticipantStatus["WAITING_LIST"] = "waiting-list";
    ActivityParticipantStatus["PAYMENT_IN_PROGRESS"] = "payment-in-progress";
    ActivityParticipantStatus["REGISTRATION_IN_PROGRESS"] = "registration-in-progress";
    ActivityParticipantStatus["APPROVAL_PENDING"] = "approval-pending";
    ActivityParticipantStatus["REGISTERED"] = "registered";
    ActivityParticipantStatus["ARRIVED"] = "arrived";
    ActivityParticipantStatus["NO_SHOW"] = "no-show";
})(ActivityParticipantStatus = exports.ActivityParticipantStatus || (exports.ActivityParticipantStatus = {}));
var RenderAs;
(function (RenderAs) {
    RenderAs["WaitingList"] = "waiting-list";
    RenderAs["Registered"] = "registered";
    RenderAs["Disabled"] = "disabled";
    RenderAs["Open"] = "open";
    RenderAs["OpenWaitingList"] = "openwaiting-list";
    RenderAs["PaymentInProgress"] = "payment-in-progress";
    RenderAs["RegistrationInProgress"] = "registration-in-progress";
    RenderAs["ApprovalPending"] = "approval-pending";
    RenderAs["Arrived"] = "arrived";
    RenderAs["NoShow"] = "no-show";
})(RenderAs = exports.RenderAs || (exports.RenderAs = {}));
exports.ImmutableStatuses = [
    ActivityParticipantStatus.PAYMENT_IN_PROGRESS,
    ActivityParticipantStatus.REGISTRATION_IN_PROGRESS,
    ActivityParticipantStatus.APPROVAL_PENDING,
    ActivityParticipantStatus.ARRIVED,
    ActivityParticipantStatus.NO_SHOW,
];
